import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, delay, finalize, map, retryWhen, switchMap } from 'rxjs/operators';
import { StorageService } from '../services/storage.service';


@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {


  constructor(private storageService: StorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let valid = false;
    console.log("req.body.--.", req.body);
    //console.log("req.body.data.--.", req.body.data);
    
    try {
      if (req.body.data.data) {
        console.log("existe JAVA Service", req.body.data.data);
        valid = (req.body.data.data == "{\"infoT\":\"DealerWeb\"}");
        console.log("valid--R", valid);
      } else {
        console.log("no existe");
      }
    } catch (error) {
      console.log("errorTry", error);
    }

    //console.log("Peticion, Interceptor", req.body);
    if (req.url.includes("/uaa/oauth/token")) {
      console.log("tmv");
      return from(this.storageService.getStorage('TOKEN')).pipe(
        switchMap(token => {
          console.log("tokenSw", token);
          
          req = this.addTokenBasic(req, token);
          return next.handle(req).pipe(
            retryWhen(err => {
              let retries = 1;
              return err.pipe(
                delay(1000),
                map(error => {
                  if (retries++ === 1) {
                    throw error;
                  }
                  return error;
                })
              );
            }),
            catchError(err => {
              console.log('err', err);
              return throwError(err);
            }),
            finalize(() => {

            })
          );
        })
      );

    } else if (valid || this.requestedForToken(req)) {
      let sto = this.storageService.getStorage('TOKENJAVA');
      console.log("sto..", sto);

      return from(this.storageService.getStorage('TOKENJAVA')).pipe(
        switchMap(tokenJ => {
          console.log("TOKENJAVA", tokenJ);
          req = this.addToken(req, tokenJ);
          return next.handle(req).pipe(
            retryWhen(err => {
              let retries = 1;
              return err.pipe(
                delay(1000),
                map(error => {
                  if (retries++ === 1) {
                    throw error;
                  }
                  return error;
                })
              );
            }),
            catchError(err => {
              console.log('err', err);
              return throwError(err);
            }),
            finalize(() => {

            })
          );
        })
      );
    } else {
      console.log("Else");
      
      return from(this.storageService.getStorage('TOKEN')).pipe(
        switchMap(token => {
          req = this.addToken(req, token);
          return next.handle(req).pipe(
            retryWhen(err => {
              let retries = 1;
              return err.pipe(
                delay(1000),
                map(error => {
                  if (retries++ === 1) {
                    throw error;
                  }
                  return error;
                })
              );
            }),
            catchError(err => {
              console.log('err', err);
              return throwError(err);
            }),
            finalize(() => {

            })
          );
        })
      );


    }



  }

  private requestedForToken(request: HttpRequest<any>) {
    return request.url.includes("/people/findEnrollmentPersonTMV") || request.url.includes("people/upload") 
  }

  private addToken(req: HttpRequest<any>, token: any) {
    console.log("token",token);
    
    if (token.value) {
      console.log("token.value", token.value);
      
      const headers = {
        Authorization: `Bearer ${token.value}`,
      };

      let clone: HttpRequest<any>;
      clone = req.clone({
        setHeaders: headers
      });

      return clone;
    }

    return req;

  }

  private addTokenBasic(req: HttpRequest<any>, token: any) {

    if (token.value) {


      const headers = {
        Authorization: `Basic dXNlcmFwcDpwYXNzd29yZA==`,
      };

      let clone: HttpRequest<any>;
      clone = req.clone({
        setHeaders: headers
      });

      return clone;
    }

    return req;

  }

}
